import { GET_API } from "../../Functionalities/APIs";

export const ManageDeliveryBoyReviews = async (e, data, keyword, params) => {
    let path = "/review/reviewdeliveryboy/";
    if (keyword == "get") {
        // void 0
        let result = GET_API("", params, path);
        return await result.then((result) => {
            // void 0
            //          let value=-1
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

}


export const ManageDeliveryBoyWallet = async (e, data, keyword, params) => {
     
    let path = "/accounts/"
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}
